import { useContext } from 'react';
import SessionExpiredContext from '../context/SessionExpiredContext';

/**
 * Custom hook to easily access the SessionExpiredContext
 * 
 * @returns {Object} The session expired context values
 */
const useSessionExpired = () => {
  const context = useContext(SessionExpiredContext);
  
  if (!context) {
    throw new Error('useSessionExpired must be used within a SessionExpiredProvider');
  }
  
  return context;
};

export default useSessionExpired;